import { Component, OnInit } from "@angular/core";
import { EChartsOption, SeriesOption } from "echarts";
import { UserService } from "../../services/userService/user.service";
import * as moment from "moment";
import { ToastrService } from "ngx-toastr";
import { NgxSpinnerService } from "ngx-spinner";
import { NgbDateParserFormatter } from "@ng-bootstrap/ng-bootstrap";
import { DatePipe } from "@angular/common";
import { Router } from "@angular/router";

@Component({
  selector: "app-report-dashboard",
  templateUrl: "./report-dashboard.component.html",
  styleUrls: ["./report-dashboard.component.css"],
})
export class ReportDashboardComponent implements OnInit {
  // dropdownSetting: any = {};

  BookingTarget: any;
  BookingAchieved: any;
  completionRate: any;

  MonthlyBookingVsAchieveList: any;
  ExpectedOrdersList: any;
  PipeLineByStageList: any;
  OpenInquiriesList: any;
  TopSalesProductsList: any;
  OrdersByMTIList: any;
  InquiryByProjectSourceList: any;
  InquiryByApplicationList: any;
  LostInquiriesList: any;
  InquiryInfoList: any;

  ClosingValue: any = 0;
  CreatedValue: any = 0;
  InquiryClosing: any = 0;
  InquiryCreated: any = 0;
  OverdueInquiry: any = 0;
  OverdueValue: any = 0;
  ClosingPer: any = 0;
  CreatedPer: any = 0;
  OverduePer: any = 0;

  YearlyBookingVsAchieveChartOption: EChartsOption;
  MonthlyBookingVsAchieveChartOption: EChartsOption;
  ExpectedOrdersChartOption: EChartsOption;
  PipeLineByStageChartOption: EChartsOption;
  OpenInquiriesChartOption: EChartsOption;
  OrdersByMTIChartOption: EChartsOption;
  LostInquiriesChartOption: EChartsOption;
  chartOption2: EChartsOption;

  selectedTheme = "macarons";
  FYArray: Object;

  start: any = "";
  end: any = "";

  permission: any;
  roleId: any;
  baseurl: string;
  Account: string;
  Finance: string;
  General: string;
  Sales: string;
  Service: string;

  //Dropdown setting variables
  businessVerticalDropdownSetting: any = {};
  salesEnggDropdownSetting: any = {};
  quotEnggDropdownSetting: any = {};
  probabilitySetting: any = {};

  //Filter List varialbles
  businessVertical: any = [];
  businessVerticalResponseArray: any = [];
  selectedBusinessVertical: any = [];
  selectedBusinessVerticalName: string = "";
  selectedBusinessVerticalNameId: any = "";

  salesQuotationEngg: any = [];
  salesQuotationEnggResponseArray: any = [];
  selectedQuotationEngg: any = [];
  selectedQuotationEnggName: string = "";
  selectedQuotationEnggId: any = "";
  selectedSalesEngg: any = [];
  selectedSalesEnggName: string = "";
  selectedSalesEnggId: any = "";

  probability: any = [];
  probabilityResponseArray: any = [];
  selectedProbability: any = [];
  selectedProbabilityName: string = "";
  selectedProbabilityNameId: any = "";

  disableDate() {
    return false;
  }

  ranges: any = {
    Today: [moment(), moment()],
    Yesterday: [moment().subtract(1, "days"), moment().subtract(1, "days")],
    "Last 7 Days": [moment().subtract(6, "days"), moment()],
    "Last 30 Days": [moment().subtract(29, "days"), moment()],
    "This Month": [moment().startOf("month"), moment().endOf("month")],
    "Last Month": [
      moment().subtract(1, "month").startOf("month"),
      moment().subtract(1, "month").endOf("month"),
    ],
  };

  invalidDates: moment.Moment[] = [
    moment().add(2, "days"),
    moment().add(3, "days"),
    moment().add(5, "days"),
  ];

  isInvalidDate = (m: moment.Moment) => {
    return this.invalidDates.some((d) => d.isSame(m, "day"));
  };

  date_range: any = {
    startDate: moment().startOf("year"),
    endDate: moment().endOf("year"),
  };

  constructor(
    public formatter: NgbDateParserFormatter,
    private datePipe: DatePipe,
    private UserService: UserService,
    private toastr: ToastrService,
    private spinner: NgxSpinnerService,
    private router: Router
  ) {}

  ngOnInit(): void {
    let permi = JSON.parse(localStorage.getItem("Permission"));
    this.permission = this.UserService.decryptData(permi);
    let rId = localStorage.getItem("roleId");
    this.roleId = this.UserService.decryptData(rId);
    this.Account = localStorage.getItem("Account");
    this.Finance = localStorage.getItem("Finance");
    this.General = localStorage.getItem("General");
    this.Sales = localStorage.getItem("Sales");
    this.Service = localStorage.getItem("Service");
    if (this.permission.ReportDashboard_View != 1 && this.roleId != 1) {
      this.toastr.error("You do not have permission");
      this.router.navigate(["/profile"]);
      return;
    }

    // this.dropdownSetting = {
    //   singleSelection: true,
    //   text: "Financial Year",
    //   selectAllText: "Select All",
    //   unSelectAllText: "UnSelect All",
    //   enableSearchFilter: true,
    //   enableFilterSelectAll: false,
    //   classes: "custom-class",
    //   badgeShowLimit: 1,
    //   disabled: true,
    // };

    //Filter Dropdown Settings
    this.businessVerticalDropdownSetting = {
      singleSelection: true,
      text: "Business Vertical",
      selectAllText: "Select All",
      unSelectAllText: "UnSelect All",
      enableSearchFilter: true,
      enableFilterSelectAll: true,
      classes: "custom-class",
      badgeShowLimit: 1,
    };

    this.salesEnggDropdownSetting = {
      singleSelection: true,
      text: "Sales Engineer",
      selectAllText: "Select All",
      unSelectAllText: "UnSelect All",
      enableSearchFilter: true,
      enableFilterSelectAll: true,
      classes: "custom-class",
      badgeShowLimit: 1,
    };

    this.quotEnggDropdownSetting = {
      singleSelection: true,
      text: "Quotation Engineer",
      selectAllText: "Select All",
      unSelectAllText: "UnSelect All",
      enableSearchFilter: true,
      enableFilterSelectAll: true,
      classes: "custom-class",
      badgeShowLimit: 1,
    };
    this.probabilitySetting = {
      singleSelection: true,
      text: "Probability",
      selectAllText: "Select All",
      unSelectAllText: "UnSelect All",
      enableSearchFilter: true,
      enableFilterSelectAll: true,
      classes: "custom-class",
      badgeShowLimit: 1,
    };

    this.BusinessVerticalList();
    this.SalesQuotationEnggList();
    this.Probability();
    this.GetFinancialYear();
    this.GetYearlyTargetVsAchievement();
    this.GetMonthlyTargetVsAchievement();
    this.GetChartData();

    this.selectedFinancialName = new Date().getFullYear().toString();
    this.selectedFinancialId = new Date().getFullYear().toString();
    this.selectedYear.push({
      id: this.selectedFinancialId,
      itemName: this.selectedFinancialName,
    });
  }

  clearEndDate() {
    this.date_range = null;
  }

  YearList: any = [];
  GetFinancialYear() {
    let data = {};
    this.UserService.GetFinancialYear(data).subscribe((res) => {
      if (res["result"] == "Success") {
        this.FYArray = res;
        for (const yearData of this.FYArray["FinancialYear"]) {
          this.YearList.push({
            id: yearData["FY_Year"],
            itemName: yearData["FY_YearName"],
          });
        }
      } else {
        this.FYArray = [];
      }
    });
  }
  selectedYear: any = [];
  selectedFinancialName: string = "";
  selectedFinancialId: string = "";
  onYearSelect(item: any) {
    this.selectedFinancialName = "";
    this.selectedFinancialId = "";
    this.selectedYear.forEach((element) => {
      this.selectedFinancialName = element["itemName"];
      this.selectedFinancialId = element["id"];
    });
  }

  BusinessVerticalList() {
    let data = {};
    this.UserService.GetBusinessVertical(data).subscribe((res) => {
      if (res["result"] == "success") {
        this.businessVerticalResponseArray = res;
        this.businessVertical = [{ id: "", itemName: "All" }];
        for (
          let i = 0;
          i < this.businessVerticalResponseArray["Data"].length;
          i++
        ) {
          this.businessVertical.push({
            id: this.businessVerticalResponseArray["Data"][i]["Id"],
            itemName: this.businessVerticalResponseArray["Data"][i]["Name"],
          });
        }
      } else {
        this.businessVerticalResponseArray = [];
      }
    });
  }
  onBusinessSelect(item: any) {
    this.selectedBusinessVerticalName = "";
    this.selectedBusinessVerticalNameId = "";
    this.selectedBusinessVertical.forEach((element) => {
      this.selectedBusinessVerticalName = element["itemName"];
      this.selectedBusinessVerticalNameId = element["id"];
    });
  }

  SalesQuotationEnggList() {
    let data = {};
    this.UserService.GetAllUser(data).subscribe((res) => {
      if (res["result"] == "success") {
        this.salesQuotationEnggResponseArray = res;
        this.salesQuotationEngg = [{ id: "", itemName: "All" }];
        for (
          let i = 0;
          i < this.salesQuotationEnggResponseArray["Data"].length;
          i++
        ) {
          this.salesQuotationEngg.push({
            id: this.salesQuotationEnggResponseArray["Data"][i]["UserId"],
            itemName:
              this.salesQuotationEnggResponseArray["Data"][i]["UserName"] +
              " (" +
              this.salesQuotationEnggResponseArray["Data"][i]["EmailId"] +
              ") " +
              this.salesQuotationEnggResponseArray["Data"][i]["EmployeeId"],
          });
        }
      } else {
        this.salesQuotationEnggResponseArray = [];
      }
    });
  }
  onQuotationEnggSelect(item: any) {
    this.selectedQuotationEnggName = "";
    this.selectedQuotationEnggId = "";
    this.selectedQuotationEngg.forEach((element) => {
      this.selectedQuotationEnggName = element["itemName"];
      this.selectedQuotationEnggId = element["id"];
    });
  }
  onSalesEnggSelect(item: any) {
    this.selectedSalesEnggName = "";
    this.selectedSalesEnggId = "";
    this.selectedSalesEngg.forEach((element) => {
      this.selectedSalesEnggName = element["itemName"];
      this.selectedSalesEnggId = element["id"];
    });
  }

  Probability() {
    let data = {};
    this.UserService.GetInquiryProbabilityList(data).subscribe((res) => {
      if (res["result"] == "success") {
        this.probabilityResponseArray = res;
        this.probability = [{ id: "", itemName: "All" }];
        for (const probabilityData of this.probabilityResponseArray["Data"]) {
          this.probability.push({
            id: probabilityData["InquiryProbabilityId"],
            itemName: probabilityData["Percentage"],
          });
        }
      } else {
        this.probabilityResponseArray = [];
      }
    });
  }
  onProbabilitySelect(item: any) {
    this.selectedProbabilityName = "";
    this.selectedProbabilityNameId = "";
    this.selectedProbability.forEach((element) => {
      this.selectedProbabilityName = element["itemName"];
      this.selectedProbabilityNameId = element["id"];
    });
  }

  GetYearlyTargetVsAchievement() {
    let data = {};
    this.spinner.show();
    this.UserService.GetYearlyTargetVsAchievement(data).subscribe(
      (res) => {
        this.spinner.hide();
        if (res["result"] == "success") {
          this.BookingTarget = res["Data"]["BookingTarget"];
          this.BookingAchieved = res["Data"]["BookingAchieved"];
          this.completionRate =
            (this.BookingAchieved / this.BookingTarget) * 100;

          this.YearlyBookingVsAchieveChartOption = {
            title: {
              text: "Yearly Booking Target Vs Achievement",
              // subtext: '',
              left: "center",
            },
            series: [
              {
                type: "gauge",
                startAngle: 180,
                endAngle: 0,
                detail: {
                  formatter: (params) => {
                    return `${this.BookingAchieved}/${this.BookingTarget}`;
                  },
                  offsetCenter: [0, "20%"],
                  fontSize: 18,
                },
                data: [{ value: this.completionRate, name: "" }],
                radius: "85%",
                axisLine: {
                  lineStyle: {
                    color: [
                      [0.3, "#000"],
                      [0.6, "#ff0000"],
                      [0.9, "#FFBF00"],
                      [1, "#008000"],
                    ],
                    width: 20,
                  },
                },
                pointer: {
                  length: "95%",
                },
                axisTick: {
                  show: false,
                  length: 5,
                  lineStyle: {
                    color: "#000",
                  },
                  splitNumber: 5,
                },
                axisLabel: {
                  show: true,
                  formatter: (value: number) => {
                    if (value % 20 === 0) {
                      return value + "%";
                    } else {
                      return "";
                    }
                  },
                  distance: 25,
                },
                splitLine: {
                  show: true,
                  length: 8,
                  lineStyle: {
                    color: "#000",
                    width: 1,
                  },
                },
              },
            ],
          };
        } else if (res["result"] == "Failed") {
          this.toastr.error(res["Msg"]);
          this.spinner.hide();
        } else {
          this.toastr.error(res["Msg"]);
          this.spinner.hide();
        }
      },
      (err) => {
        this.spinner.hide();
        if (err && (err.Msg || err.Message)) {
          this.toastr.error(err.Msg || err.Message);
        }
      }
    );
  }

  GetMonthlyTargetVsAchievement() {
    let data = {};
    this.spinner.show();
    this.UserService.GetMonthlyTargetVsAchievement(data).subscribe(
      (res) => {
        this.spinner.hide();
        if (res["result"] == "success") {
          this.MonthlyBookingVsAchieveList = res["Data"];
          this.MonthlyBookingVsAchieveChartOption =
            this.generateBarChartOptions(this.MonthlyBookingVsAchieveList);
        } else if (res["result"] == "Failed") {
          this.toastr.error(res["Msg"]);
          this.spinner.hide();
        } else {
          this.toastr.error(res["Msg"]);
          this.spinner.hide();
        }
      },
      (err) => {
        this.spinner.hide();
        if (err && (err.Msg || err.Message)) {
          this.toastr.error(err.Msg || err.Message);
        }
      }
    );
  }

  generateBarChartOptions(data: any[]): EChartsOption {
    const yAxisData = data.map((item) => item.Month);
    const seriesData: SeriesOption[] = [
      {
        name: "MonthlyTarget",
        type: "bar",
        stack: "total",
        data: data.map((item) => item.MonthlyTarget.toFixed(2)),
        itemStyle: {
          color: "#3498db",
        },
      },
      {
        name: "MonthlyAchieved",
        type: "bar",
        stack: "total",
        data: data.map((item) => item.MonthlyAchieved),
        itemStyle: {
          color: "#348204",
        },
      },
    ];

    const option: EChartsOption = {
      tooltip: {
        trigger: "axis",
        axisPointer: {
          type: "shadow",
        },
      },
      title: {
        text: "Monthly Booking Target Vs Achievement",
        // subtext: 'Sales Funnel',
        left: "center",
      },
      legend: {
        data: ["MonthlyTarget", "MonthlyAchieved"],
        top: "bottom",
      },
      xAxis: {
        type: "value",
        axisLabel: {
          formatter: function (value: number) {
            return value >= 1000000 ? `${value / 1000000}M` : `${value}`;
          },
        },
      },
      yAxis: {
        type: "category",
        data: yAxisData,
      },
      grid: {
        left: "15%",
        // right: '10%',
        top: "10%",
        bottom: "15%",
      },
      series: seriesData,
    };

    return option;
  }

  GetChartData() {
    let data = {
      StartDate: "",
      EndDate: "",
    };
    this.spinner.show();
    this.UserService.GetReportChartData(data).subscribe(
      (res) => {
        this.spinner.hide();
        if (res["result"] == "success") {
          this.ExpectedOrdersList = res["ExpectedOrderList"];
          this.PipeLineByStageList = res["PipeLineByStageList"];
          this.OpenInquiriesList = res["OpenInquiryList"];
          this.TopSalesProductsList = res["TopSalesProductsList"];
          this.OrdersByMTIList = res["OrdersByMTIList"];
          this.InquiryByProjectSourceList = res["InquiryByProjectSourceList"];
          this.InquiryByApplicationList = res["InquiryByApplicationList"];
          this.LostInquiriesList = res["LostInquiryList"];
          this.InquiryInfoList = res["InquiryInfo"];

          this.ClosingValue = this.InquiryInfoList["ClosingValue"];
          this.CreatedValue = this.InquiryInfoList["CreatedValue"];
          this.InquiryClosing = this.InquiryInfoList["InquiryClosing"];
          this.InquiryCreated = this.InquiryInfoList["InquiryCreated"];
          this.OverdueInquiry = this.InquiryInfoList["OverdueInquiry"];
          this.OverdueValue = this.InquiryInfoList["OverdueValue"];

          this.CreateExpectedOrdersChart();
          this.CreatePipeLineByStageChart();
          this.CreateOpenInquiriesChart();
          this.CreateOrdersByMTIChart();
          this.CreateLostInquiriesChart();
        } else if (res["result"] == "Failed") {
          this.toastr.error(res["Msg"]);
          this.spinner.hide();
        } else {
          this.toastr.error(res["Msg"]);
          this.spinner.hide();
        }
      },
      (err) => {
        this.spinner.hide();
        if (err && (err.Msg || err.Message)) {
          this.toastr.error(err.Msg || err.Message);
        }
      }
    );
  }

  CreateExpectedOrdersChart() {
    this.ExpectedOrdersChartOption = {
      title: {
        text: "Expected Orders",
        // subtext: 'Sales Funnel',
        left: "center",
      },
      tooltip: {
        trigger: "item",
        // formatter: '{a} <br/>{b}: {c} ({d}%)'
        formatter: (params: any) => {
          const item = this.ExpectedOrdersList.find(
            (obj) => obj.Name === params.name
          );
          return `${params.name}: ${params.value} (ReportedValue: ${
            item ? item.ReportedValue : "N/A"
          })`;
        },
      },
      series: [
        {
          name: "InquiryCount",
          type: "pie",
          radius: "75%",
          label: {
            // position: 'inside',
            formatter: "{b}:\n{c}",
          },
          data: this.ExpectedOrdersList.map((item) => ({
            value: item.InquiryCount,
            name: item.Name,
          })),
          emphasis: {
            itemStyle: {
              shadowBlur: 10,
              shadowOffsetX: 0,
              shadowColor: "rgba(0, 0, 0, 0.5)",
            },
          },
        },
      ],
    };
  }

  CreatePipeLineByStageChart() {
    this.PipeLineByStageChartOption = {
      title: {
        text: "Pipe Line By Stage",
        left: "center",
      },
      tooltip: {
        trigger: "item",
        formatter: (params: any) => {
          const item = this.PipeLineByStageList.find(
            (obj) => obj.StageName === params.name
          );
          return `${params.name}: ${params.value} (ReportedValue: ${
            item ? item.ReportedValue : "N/A"
          })`;
        },
      },
      series: [
        {
          name: "InquiryCount",
          type: "funnel",
          width: "80%",
          height: "90%",
          left: "10%",
          top: "10%",
          data: this.PipeLineByStageList.map((item) => ({
            value: item.InquiryCount,
            name: item.StageName,
          })),
          emphasis: {
            focus: "series",
            label: {
              show: true,
              formatter: "{b}: {c}",
              position: "inside",
            },
            itemStyle: {
              shadowBlur: 10,
              shadowOffsetX: 1,
              shadowColor: "rgba(0, 0, 0, 0.5)",
            },
          },
          label: {
            formatter: "{b}: {c}",
          },
        },
      ],
    };
  }

  CreateOpenInquiriesChart() {
    this.OpenInquiriesChartOption = {
      title: {
        text: "Open Inquiries",
        left: "center",
      },
      tooltip: {
        trigger: "item",
        formatter: (params: any) => {
          const item = this.OpenInquiriesList.find(
            (obj) => obj.UserName === params.name
          );
          return `${params.name}: ${params.value} (ReportedValue: ${
            item ? item.ReportedValue : "N/A"
          })`;
        },
      },
      graphic: [
        {
          type: "text",
          left: "center",
          top: "center",
          style: {
            text: `Total ReportedValue:\n ${this.getTotalOpenReportedValue()}`,
            fill: "#333",
            fontSize: 10,
          },
        },
      ],
      series: [
        {
          name: "InquiryCount",
          type: "pie",
          radius: ["40%", "60%"],
          label: {
            formatter: "{b}: {c}",
          },
          data: this.OpenInquiriesList.map((item) => ({
            value: item.InquiryCount,
            name: item.UserName,
          })),
          emphasis: {
            itemStyle: {
              shadowBlur: 10,
              shadowOffsetX: 0,
              shadowColor: "rgba(0, 0, 0, 0.5)",
            },
          },
        },
      ],
    };
  }

  getTotalOpenReportedValue(): number {
    const CalVal = this.OpenInquiriesList.reduce(
      (total, item) => total + item.ReportedValue,
      0
    );
    return CalVal.toFixed(2);
  }

  CreateOrdersByMTIChart() {
    this.OrdersByMTIChartOption = {
      title: {
        text: "Orders By MTI",
        left: "center",
      },
      tooltip: {
        trigger: "item",
        formatter: (params: any) => {
          const item = this.OrdersByMTIList.find(
            (obj) => obj.StageName === params.name
          );
          return `${params.name}: ${params.value} (ReportedValue: ${
            item ? item.TotalReportedValue : "N/A"
          })`;
        },
      },
      series: [
        {
          name: "OrderCount",
          type: "pie",
          radius: "75%",
          startAngle: 180,
          label: {
            formatter: "{b}: {c}",
          },
          data: this.OrdersByMTIList.map((item) => ({
            value: item.OrderCount,
            name: item.StageName,
          })),
          emphasis: {
            itemStyle: {
              shadowBlur: 10,
              shadowOffsetX: 0,
              shadowColor: "rgba(0, 0, 0, 0.5)",
            },
          },
        },
      ],
    };
  }

  CreateLostInquiriesChart() {
    this.LostInquiriesChartOption = {
      title: {
        text: "Lost Inquiries",
        left: "center",
      },
      tooltip: {
        trigger: "item",
        formatter: (params: any) => {
          const item = this.LostInquiriesList.find(
            (obj) => obj.ReasonName === params.name
          );
          return `${params.name}: ${params.value} (ReportedValue: ${
            item ? item.ReportedValue : "N/A"
          })`;
        },
      },
      graphic: [
        {
          type: "text",
          left: "center",
          top: "center",
          style: {
            text: `Total ReportedValue:\n ${this.getTotalLostReportedValue()}`,
            fill: "#333",
            fontSize: 10,
          },
        },
      ],
      series: [
        {
          name: "InquiryCount",
          type: "pie",
          radius: ["40%", "60%"],
          label: {
            formatter: "{b}: {c}",
          },
          data: this.LostInquiriesList.map((item) => ({
            value: item.InquiryCount,
            name: item.ReasonName,
          })),
          emphasis: {
            itemStyle: {
              shadowBlur: 10,
              shadowOffsetX: 0,
              shadowColor: "rgba(0, 0, 0, 0.5)",
            },
          },
        },
      ],
    };
  }

  getTotalLostReportedValue(): number {
    const CalVal = this.LostInquiriesList.reduce(
      (total, item) => total + item.ReportedValue,
      0
    );
    return CalVal.toFixed(2);
  }

  applyFilter() {
    if (this.date_range != null) {
      if (this.date_range.startDate != "" && this.date_range.endDate != "") {
        this.start = this.datePipe.transform(
          this.date_range.startDate,
          "yyyy-MM-dd"
        );
        this.end = this.datePipe.transform(
          this.date_range.endDate,
          "yyyy-MM-dd"
        );
      }
    } else {
      this.start = "";
      this.end = "";
    }
    let data = {
      StartDate: this.start,
      EndDate: this.end,
      BusinessVertical: this.selectedBusinessVerticalNameId,
      SalesEngineer: this.selectedSalesEnggId,
      QuotationEngineer: this.selectedQuotationEnggId,
      Probability: this.selectedProbabilityNameId,
    };
    this.spinner.show();
    this.UserService.GetReportChartData(data).subscribe(
      (res) => {
        this.spinner.hide();
        if (res["result"] == "success") {
          this.ExpectedOrdersList = res["ExpectedOrderList"];
          this.PipeLineByStageList = res["PipeLineByStageList"];
          this.OpenInquiriesList = res["OpenInquiryList"];
          this.TopSalesProductsList = res["TopSalesProductsList"];
          this.OrdersByMTIList = res["OrdersByMTIList"];
          this.InquiryByProjectSourceList = res["InquiryByProjectSourceList"];
          this.InquiryByApplicationList = res["InquiryByApplicationList"];
          this.LostInquiriesList = res["LostInquiryList"];
          this.InquiryInfoList = res["InquiryInfo"];

          this.ClosingValue = this.InquiryInfoList["ClosingValue"];
          this.CreatedValue = this.InquiryInfoList["CreatedValue"];
          this.InquiryClosing = this.InquiryInfoList["InquiryClosing"];
          this.InquiryCreated = this.InquiryInfoList["InquiryCreated"];
          this.OverdueInquiry = this.InquiryInfoList["OverdueInquiry"];
          this.OverdueValue = this.InquiryInfoList["OverdueValue"];

          this.CreateExpectedOrdersChart();
          this.CreatePipeLineByStageChart();
          this.CreateOpenInquiriesChart();
          this.CreateOrdersByMTIChart();
          this.CreateLostInquiriesChart();
        } else if (res["result"] == "Failed") {
          this.toastr.error(res["Msg"]);
          this.spinner.hide();
        } else {
          this.toastr.error(res["Msg"]);
          this.spinner.hide();
        }
      },
      (err) => {
        this.spinner.hide();
        if (err && (err.Msg || err.Message)) {
          this.toastr.error(err.Msg || err.Message);
        }
      }
    );
  }

  resetData() {
    this.selectedFinancialName = "";
    this.selectedFinancialId = "";
    this.selectedYear = [];
    this.selectedBusinessVerticalName = "";
    this.selectedBusinessVerticalNameId = "";
    this.selectedBusinessVertical = [];
    this.selectedQuotationEnggName = "";
    this.selectedQuotationEnggId = "";
    this.selectedQuotationEngg = [];
    this.selectedSalesEnggName = "";
    this.selectedSalesEnggId = "";
    this.selectedSalesEngg = [];
    this.selectedProbabilityName = "";
    this.selectedProbabilityNameId = "";
    this.selectedProbability = [];
    this.date_range = {
      startDate: moment().startOf("year"),
      endDate: moment().endOf("year"),
    };
    this.ngOnInit();
  }
}
